import React from 'react'
import { COLORS } from '@btime/constants'
import { useOpenServiceOrderAutomaticDistributionEditModal } from '../../../../utils/routes/modals/modalsActions'
import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import Icon from '../../../../packages/kiti/components/shapes/Icon'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import Link from '../../../../components/actions/Link'
import IconText from '../../../../components/presentation/IconText'

const Header = () => {
  const openServiceOrderAutomaticDistributionEditModal = useOpenServiceOrderAutomaticDistributionEditModal()

  return (
    <Grid gap={0.6} align="center">
      <Col>
        <Icon name="RiUserSettingsLine" color="dark3" size={1.4} />
      </Col>
      <Col>
        <Title size="h4" noMargin>
          Distibuição automática
        </Title>
      </Col>

      <Col flex={1} />

      <Col>
        <Link onClick={openServiceOrderAutomaticDistributionEditModal}>
          <IconText
            iconName="BsPlusCircleFill"
            label="Nova Configuração"
            size="small"
            right
            iconSize=".8rem"
            color={COLORS.purple}
            noWrap
          />
        </Link>
      </Col>
    </Grid>
  )
}

export default Header
